import { render, staticRenderFns } from "./DeliveryTimeForm.vue?vue&type=template&id=0459dd42"
import script from "./DeliveryTimeForm.vue?vue&type=script&lang=ts"
export * from "./DeliveryTimeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports